// Copied verbatim from eval/dashboard/internal_web/src/components/ui/buttonStyles.ts (ATM-57). Keep in step until ATM-60 shares it.
/**
 * The classes behind `Button`, in their own module so an element that has to LOOK like a
 * button without being one — a router `Link` (`ArrowLink`, `FailureNotice`) — takes the
 * same box rather than a hand-copied one. See `Button` for what each variant is for.
 */

import { cn } from "../../lib/cn";

export type ButtonVariant = "primary" | "outline" | "accent" | "link";

export type ButtonSize = "md" | "sm";

const BASE =
  "inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-40";

const VARIANT: Record<ButtonVariant, string> = {
  primary: "rounded-pill bg-ink-strong text-surface hover:bg-ink",
  outline:
    "rounded-control border border-hairline bg-surface text-ink shadow-control hover:border-button-hover-edge hover:bg-button-hover-bg hover:text-button-hover-fg",
  accent: "rounded-pill bg-comment-action text-surface hover:brightness-95",
  link: "text-comment hover:text-ink",
};

const SIZE: Record<ButtonSize, string> = {
  md: "h-10 px-5 text-[15px]",
  sm: "h-8 px-3.5 text-cell",
};

/** The classes of a button, for an element that is not a `<button>`. */
export function buttonClass(variant: ButtonVariant = "primary", size: ButtonSize = "md"): string {
  // A link has no box, so it must not carry the box sizing either.
  return cn(BASE, VARIANT[variant], variant === "link" ? "h-auto px-0 text-cell" : SIZE[size]);
}
